<template>
  <div class="table-control">
    <GlSelectButton
      :disabled="disabled"
      grey
      :options="getExposureTableOptions"
      :value="getActiveExposureTable"
      @input="exposureChange"
    />
  </div>
</template>

<script>
// vuex
import { mapGetters, mapMutations } from 'vuex'
// components
import GlSelectButton from '@/components/gl-select-button2'

export default {
  components: {
    GlSelectButton,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    optionsForSort: {
      type: Array,
      default: () => [],
    },
    activeSort: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters('directions', [
      'getActiveExposureTable',
      'getExposureTableOptions',
      'getActiveExposurePart',
      'getActiveTypeEntityItem',
    ]),
    resolveActiveExposurePart() {
      return this.getActiveExposurePart
    },
  },
  watch: {
    resolveActiveExposurePart: {
      handler(part) {
        const resultPart =
          this.getExposureTableOptions.find(e => e.value == part.value) ||
          this.getExposureTableOptions[0]
        if (!resultPart) return
        this.SET_ACTIVE_EXPOSURE_TABLE(resultPart)
      },
    },
    getActiveTypeEntityItem: {
      handler(item) {

        const resultPart = this.getExposureTableOptions.find(
          e => e.value == item.clickedExposurePart,
        )
        if (!resultPart) return
        this.SET_ACTIVE_EXPOSURE_TABLE(resultPart)
      },
    },
  },
  methods: {
    ...mapMutations('directions', ['SET_ACTIVE_EXPOSURE_TABLE']),
    exposureChange(val) {
      this.SET_ACTIVE_EXPOSURE_TABLE(val)
    },
  },
}
</script>

<style>
.table-control {
  margin-bottom: 16px;
  padding-left: 10px;
}

.table-control .gl-select-button__item {
  padding: 4px 16px;
}

@media (max-width: 767px) {
  .table-control {
    margin-bottom: 8px;
  }
  .table-control .gl-select-button__item {
    padding: 4px 8px;
  }
}
</style>
